// extracted by mini-css-extract-plugin
export default {"wrapper":"UnavailableChipLabel_wrapper__3b3s8","label":"UnavailableChipLabel_label__OtAk4","state":"UnavailableChipLabel_state__ipjhO","info":"UnavailableChipLabel_info__SqzuA"};